import {
  UserOutlined,
  PoweroffOutlined,
  SolutionOutlined,
  KeyOutlined,
  DollarOutlined,
  PlusCircleOutlined,
  SwapOutlined,
  ReconciliationOutlined,
  CoffeeOutlined,
  CreditCardOutlined,
  SettingOutlined,
  AuditOutlined,
  FundProjectionScreenOutlined,
  PercentageOutlined,
  StarOutlined,
  ShoppingCartOutlined,
  CalendarOutlined,
  MessageOutlined,
  ScheduleOutlined
} from "@ant-design/icons";
import { logout } from "@utils/logout";
import { Link } from "react-router-dom";
import { Avatar } from "antd";
import ChangePassword from "@general/changePassword";

export const adminVerticalMenuItems = [
  {
    key: "admin-dashboard",
    icon: <UserOutlined />,
    label: <Link to="/admin-dashboard">داشبورد</Link>,
  },
  {
    key: "admin-users",
    icon: <SolutionOutlined />,
    label: <Link to="/admin-users">کاربران</Link>,
  },
  {
    key: "admin-services",
    icon: <ScheduleOutlined />,
    label: <Link to={`/admin-services/${"all"}`}>سرویس‌های کاربران</Link>,
  },
   {
    key: "admmin-messages",
    icon: <MessageOutlined />,
    label: "پیام ها",
    children: [
      {
        key: "messages",
        icon: <SwapOutlined />,
        label: <Link to={`/admin-messages`}>فهرست پیام ها</Link>,
      },
      {
        key: "admin-messages/add-messages",
        icon: <PlusCircleOutlined />,
        label: <Link to="admin-messages/add-message">پیام جدید</Link>,
      },
       {
        key: "admin-messages/birthday",
        icon: <PlusCircleOutlined />,
        label: <Link to="admin-messages/birthday">پیام تولد</Link>,
      },
    ],
  },
  {
    key: "admin-accounting",
    icon: <FundProjectionScreenOutlined />,
    label: <Link to="/admin-accounting">حسابداری</Link>,
  },
  {
    key: "admin-consultations",
    icon: <CoffeeOutlined />,
    label: <Link to={`/admin-consultations/${"all"}`}>درخواست‌های مشاوره</Link>,
  },
  {
    key: "admin-calendar",
    icon: <CalendarOutlined />,
    label: <Link to={'admin-calendar'}>تقویم اتاق جلسات</Link>,
  },
  {
    key: "admin-transactions",
    icon: <DollarOutlined />,
    label: <Link to={`/admin-transactions/${"all"}`}>تراکنش کاربران</Link>,
  },

  {
    key: "admin-invoices",
    icon: <AuditOutlined />,
    label: <Link to={`/admin-invoices/${"all"}`}>فاکتورهای کاربران</Link>,
  },
  {
    key: "admin-discounts",
    icon: <PercentageOutlined />,
    label: <Link to={`/admin-discounts`}>تخفیف ها </Link>,
  },
  {
    key: "admin-holidays",
    icon: <StarOutlined />,
    label: <Link to={`/admin-holidays`}>روزهای تعطیل</Link>,
  },
  {
    key: "admin-purchases",
    icon: <ShoppingCartOutlined />,
    label: <Link to={`/admin-purchases/${"all"}`}>خریدهای کاربران</Link>,
  },
  {
    key: "adminCoreServices",
    icon: <ReconciliationOutlined />,
    label: "خدمات صفاتک",
    children: [
      {
        key: "core-services",
        icon: <SwapOutlined />,
        label: <Link to={`/core-services`}>فهرست خدمات</Link>,
      },
      {
        key: "core-services/add-service",
        icon: <PlusCircleOutlined />,
        label: <Link to="/core-services/add-service">خدمت جدید</Link>,
      },
    ],
  },
  {
    key: "adminPackages",
    icon: <ReconciliationOutlined />,
    label: "پکیج ها",
    children: [
      {
        key: "packages",
        icon: <SwapOutlined />,
        label: <Link to={`/admin-packages`}>فهرست پکیج ها</Link>,
      },
      {
        key: "admin-packages/add-package",
        icon: <PlusCircleOutlined />,
        label: <Link to="admin-packages/add-package">پکیج جدید</Link>,
      },
    ],
  },
  {
    key: "admin-cards",
    icon: <CreditCardOutlined />,
    label: <Link to={`/admin-cards/${"all"}`}>کارت کاربران</Link>,
  },
  {
    key: "exit",
    icon: <PoweroffOutlined />,
    label: <span onClick={logout}>خروج</span>,
  },
];

export const adminHorizontalMenuItems = (profileImg, name) => {
  return [
    {
      key: "1",
      icon: profileImg ? (
        <Avatar src={profileImg} />
      ) : (
        <Avatar icon={<UserOutlined style={{ margin: 0 }} />} />
      ),
      label: name ? `خوش آمدی ${name} جان` : "خوش آمدی",
      children: [
        {
          label: <ChangePassword> تغییر رمز عبور</ChangePassword>,
          icon: <KeyOutlined />,
          key: "change-pass",
        },
        {
          label: <Link to="admin-settings">تنظیمات</Link>,
          icon: <SettingOutlined />,
          key: "admin-settings",
        },
        {
          label: (
            <span onClick={logout} style={{ width: "100%", height: "100%" }}>
              خروج
            </span>
          ),
          icon: <PoweroffOutlined onClick={logout} />,
          key: "exit",
        },
      ],
    },
  ];
};
